import setAddinObserverLoaded from '../actions/setAddinObserverLoaded';
import store from '../store/store';
import { lazyAddinCommandSurfaceItemsObserver } from 'owa-addins-core';
var addinCommandSurfaceItemsObserver;
lazyAddinCommandSurfaceItemsObserver.import().then(function (addinObserver) {
    // Framework team has plans to implement a .isLoaded property for lazy imports.
    // This will allow a component to re-render when the import finishes. Until this is available,
    // we'll use our own boolean in the store. WI: 23555
    addinCommandSurfaceItemsObserver = addinObserver;
    setAddinObserverLoaded();
});
export default function getAddinCollection(mode) {
    if (store.isAddinObserverLoaded && addinCommandSurfaceItemsObserver) {
        return addinCommandSurfaceItemsObserver(mode).get();
    }
    else {
        return null;
    }
}
//# sourceMappingURL=getAddinCollection.js.map